import { z } from 'zod';

import {
  EmployeeExternalAccountStatus,
  EmployeeExternalAccountUserType,
  type GetEmployeeExternalAccountQuery,
  type GetEmployeeQuery,
  EmployeeExternalAccountType as NativeEmployeeExternalAccountType,
} from '@/common/graphql';

import { GoogleProductAndSKU } from '../core';

export const EmployeeExternalAccount = z.object({
  employeeId: z.string().default(''),
  email: z.string().nullable().default(''),
  temporaryPassword: z.string().nullable().default(''),
  accountType: z.nativeEnum(NativeEmployeeExternalAccountType).nullable().default(null),
  status: z.nativeEnum(EmployeeExternalAccountStatus).nullable().default(null),
  userType: z.nativeEnum(EmployeeExternalAccountUserType).nullable().default(null),
  createdAt: z.string().nullable().optional(),
  requestedAt: z.string().nullable().optional(),
  changePasswordAtNextLogin: z.boolean().default(false),
  canInvokeManualCreation: z.boolean().default(false),
  googleLicenses: z.array(GoogleProductAndSKU).catch([]),
  googleAliases: z.array(z.string()).catch([]),
  slackTeamId: z.string().nullable().default(''),
  slackTeamName: z.string().nullable().default(''),
  githubUsername: z.string().nullable().default(''),
});
export type EmployeeExternalAccountType = z.infer<typeof EmployeeExternalAccount>;

type QueryEmployeeExternalAccountType =
  | NonNullable<GetEmployeeQuery['employee']>['externalAccounts'][number]
  | NonNullable<GetEmployeeExternalAccountQuery['employee']>['externalAccounts'][number];

export const parseExternalAccount = (item: QueryEmployeeExternalAccountType) =>
  ({
    ...item,
    email: item.email ?? null,
    temporaryPassword: item.__typename === 'EmployeeExternalAccountGoogle' ? (item.temporaryPassword ?? null) : null,
    userType: item.userType ?? null,
    changePasswordAtNextLogin:
      item.__typename === 'EmployeeExternalAccountGoogle' ? item.changePasswordAtNextLogin : false,
    googleLicenses: item.__typename === 'EmployeeExternalAccountGoogle' ? item.licenses : [],
    googleAliases:
      item.__typename === 'EmployeeExternalAccountGoogle'
        ? ((item as unknown as { aliases?: string[] }).aliases ?? [])
        : [],
    slackTeamId: item.__typename === 'EmployeeExternalAccountSlack' ? (item.workspace?.teamId ?? null) : null,
    slackTeamName: item.__typename === 'EmployeeExternalAccountSlack' ? (item.workspace?.teamName ?? null) : null,
    githubUsername: item.__typename === 'EmployeeExternalAccountGitHub' ? (item.githubUsername ?? null) : null,
  }) as EmployeeExternalAccountType;
